let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("irv1D")).then(() => parcelRequire('gFWiS'));